import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import type { ProjectViewProject } from '@freelancer/datastore/collections';
import { ButtonColor } from '@freelancer/ui/button';
import { ToastAlertType } from '@freelancer/ui/toast-alert';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-project-notes-input',
  template: `
    <fl-toast-alert
      i18n="Success message when adding note"
      [id]="'success-add'"
      [type]="ToastAlertType.SUCCESS"
    >
      Successfully added note.
    </fl-toast-alert>
    <fl-toast-alert
      i18n="Error message when adding note"
      [id]="'error-add'"
      [type]="ToastAlertType.SUCCESS"
    >
      Failed to add note.
    </fl-toast-alert>
    <ng-container *ngIf="project$ | flAsync as project">
      <fl-textarea
        flTrackingLabel="DescriptionTextArea"
        [control]="noteControl"
        [maxLength]="maxLength"
        [maxCharacter]="maxCharacter"
        [flMarginBottom]="'xxsmall'"
      >
      </fl-textarea>
      <div
        [ngClass]="
          maxCharacter
            ? 'ButtonContainer ButtonContainer-characterLimit'
            : 'ButtonContainer'
        "
        [flMarginBottom]="maxCharacter ? 'none' : 'xsmall'"
      >
        <fl-button
          flTrackingLabel="CancelProjectNote"
          i18n="Cancel Project Note"
          [color]="ButtonColor.TEXT_DARK"
          [flMarginRight]="'xsmall'"
          (click)="handleCancel()"
        >
          Clear
        </fl-button>
        <fl-button
          flTrackingLabel="CreateProjectNote"
          i18n="Add Project Note"
          [color]="ButtonColor.SECONDARY"
          (click)="handleAddNote(project.id)"
        >
          Add
        </fl-button>
      </div>
      <fl-hr [flMarginBottom]="'xsmall'"></fl-hr>
    </ng-container>
  `,
  styleUrls: ['./project-notes-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNotesInputComponent {
  ButtonColor = ButtonColor;
  ToastAlertType = ToastAlertType;

  @Input() maxCharacter?: number;
  @Input() maxLength?: number;
  @Input() noteControl: FormControl<string>;
  @Input() project$: Observable<ProjectViewProject>;
  @Output() onAddNote = new EventEmitter<number>();
  @Output() onCancelNote = new EventEmitter<void>();

  handleAddNote(projectId: number): void {
    this.onAddNote.emit(projectId);
  }

  handleCancel(): void {
    this.onCancelNote.emit();
  }
}
